import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "h-100 position-relative" }
const _hoisted_2 = { class: "points-map-field" }
const _hoisted_3 = {
  key: 0,
  class: "points-map-field"
}
const _hoisted_4 = { class: "points-map-field points-map-field-dates" }
const _hoisted_5 = { class: "points-map-field points-map-field-location" }
const _hoisted_6 = { class: "map-zoom-level" }
const _hoisted_7 = {
  key: 1,
  class: "points-map-hint"
}
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "map-legend"
}
const _hoisted_11 = { class: "map-legend-content" }
const _hoisted_12 = { class: "legend-label" }
const _hoisted_13 = {
  key: 3,
  class: "points-map-panel card shadow mb-0"
}
const _hoisted_14 = { class: "card-header d-flex align-items-center justify-content-between py-2" }
const _hoisted_15 = { class: "fw-semibold" }
const _hoisted_16 = { class: "text-muted fw-normal" }
const _hoisted_17 = { class: "list-group list-group-flush overflow-auto" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LControlZoom = _resolveComponent("LControlZoom")!
  const _component_LMap = _resolveComponent("LMap")!
  const _component_EstateTypeControl = _resolveComponent("EstateTypeControl")!
  const _component_LandTypeControl = _resolveComponent("LandTypeControl")!
  const _component_DateRangeControl = _resolveComponent("DateRangeControl")!
  const _component_LocationSearchControl = _resolveComponent("LocationSearchControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LMap, {
      center: _ctx.centerLatLng,
      zoom: _ctx.zoom,
      options: {zoomSnap: 0.25, preferCanvas: true, zoomControl: false, maxZoom: 21},
      class: "h-100",
      ref: "map",
      "onUpdate:zoom": _ctx.updateZoom,
      "onUpdate:bounds": _ctx.boundsChanged,
      onReady: _ctx.onMapReady
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LControlLayers, {
          position: "topright",
          onReady: _ctx.onLayersControlReady
        }, null, 8, ["onReady"]),
        (_ctx.tilesReady)
          ? (_openBlock(), _createBlock(_component_MapyCzBasicLayer, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.tilesReady)
          ? (_openBlock(), _createBlock(_component_MapyCzOrthoPhotoLayer, {
              key: 1,
              visible: false
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_LControlZoom, { position: "topright" })
      ]),
      _: 1
    }, 8, ["center", "zoom", "onUpdate:zoom", "onUpdate:bounds", "onReady"]),
    (_ctx.searchControl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["points-map-filters d-flex flex-wrap align-items-start gap-2", {'points-map-filters-hidden': _ctx.activeMarker !== null}])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_EstateTypeControl, {
              estateTypes: _ctx.estateTypes,
              emptyLabel: "Všechny typy nemovitostí",
              onChange: _ctx.estateTypeChange
            }, null, 8, ["estateTypes", "onChange"])
          ]),
          (_ctx.estateType === 'land' && _ctx.landTypes.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_LandTypeControl, {
                  landTypes: _ctx.landTypes,
                  onChange: _ctx.landTypeChange
                }, null, 8, ["landTypes", "onChange"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_DateRangeControl, {
              onChange: _ctx.dateRangeChange,
              defaultDateRange: _ctx.dateRange
            }, null, 8, ["onChange", "defaultDateRange"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_LocationSearchControl, {
              value: null,
              onInput: _ctx.updateCenterPoint,
              placeholder: "Hledat lokalitu..."
            }, null, 8, ["onInput"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, "Přiblížení " + _toDisplayString(_ctx.zoomLabel), 1),
    (_ctx.hint !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
            : (_ctx.zoomTooSmall)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "fas fa-search-plus me-2" }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.hint), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.legendItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendItems, (legendItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: legendItem.label,
                class: "legend-item"
              }, [
                _createElementVNode("span", {
                  class: "legend-marker",
                  style: _normalizeStyle({backgroundColor: legendItem.color})
                }, null, 4),
                _createElementVNode("span", _hoisted_12, _toDisplayString(legendItem.label), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeMarker !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, [
              _cache[2] || (_cache[2] = _createTextVNode("Na tomto místě ", -1)),
              _createElementVNode("span", _hoisted_16, "· " + _toDisplayString(_ctx.activeMarker.points.length), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "Zavřít",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePanel && _ctx.closePanel(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeMarker.points, (point) => {
              return (_openBlock(), _createElementBlock("a", {
                key: point.link,
                href: "javascript:",
                class: "list-group-item list-group-item-action d-flex align-items-start gap-2 py-2",
                onClick: () => _ctx.pointClicked(point)
              }, [
                _createElementVNode("span", {
                  class: "legend-marker mt-1",
                  style: _normalizeStyle({backgroundColor: point.color})
                }, null, 4),
                _createElementVNode("span", {
                  class: "flex-fill min-w-0",
                  innerHTML: point.name
                }, null, 8, _hoisted_19)
              ], 8, _hoisted_18))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}